import { render, staticRenderFns } from "./selectcustomer.vue?vue&type=template&id=02968f8a&"
import script from "./selectcustomer.vue?vue&type=script&lang=ts&"
export * from "./selectcustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports